import { productService } from './ProductService';
import { BRANCHES } from '../config/siteConfig';
import { supabase } from '../lib/supabase';
import { isBusinessHoursActive } from '../utils/businessHours';

export interface PhoneStats {
    number: string;
    count: number;
}

export interface BranchStats {
    name: string;
    count: number;
    phones: PhoneStats[];
}

export interface BranchCount {
    name: string;
    count: number;
}

export interface ProductQueryStats {
    id: string;
    name: string;
    count: number;
    branches: BranchCount[];
}

export interface DashboardStats {
    totalProducts: number;
    whatsappQueries: number;
    activeBranches: number;
    queriesChange?: string;
    queriesByBranch: BranchStats[];
    topProducts: ProductQueryStats[];
}

export class DashboardService {
    /**
     * Obtiene las estadísticas para el panel administrativo
     */
    async getStats(): Promise<DashboardStats> {
        try {
            // Obtener estadísticas agregadas desde la RPC
            const { data, error } = await supabase.rpc('get_dashboard_stats');

            if (error) {
                console.error('Error fetching dashboard stats from RPC:', error);
                throw error;
            }

            // Sucursales activas (Basado en el horario actual)
            const isOpen = isBusinessHoursActive();
            const activeBranches = isOpen ? BRANCHES.length : 0;

            return {
                totalProducts: data.totalProducts,
                whatsappQueries: data.whatsappQueries,
                activeBranches,
                queriesChange: data.queriesChange,
                queriesByBranch: data.queriesByBranch,
                topProducts: data.topProducts
            };
        } catch (error) {
            console.error('Error in DashboardService:', error);
            return {
                totalProducts: 0,
                whatsappQueries: 0,
                activeBranches: 0,
                queriesByBranch: [],
                topProducts: []
            };
        }
    }
    /**
     * Obtiene la serie de tiempo para los KPIs históricos
     * @param bucket 'day' | 'month' | 'year'
     * @param monthsToLookBack Cantidad de meses hacia atrás a consultar
     */
    async getKPISeries(bucket: 'day' | 'month' | 'year', monthsToLookBack: number = 12) {
        try {
            const now = new Date();
            const startDate = new Date();
            startDate.setMonth(now.getMonth() - monthsToLookBack);

            const { data, error } = await supabase.rpc('get_whatsapp_kpi_series', {
                start_date: startDate.toISOString(),
                time_bucket: bucket
            });

            if (error) {
                console.error('Error fetching KPI series from RPC:', error);
                throw error;
            }

            return data || [];
        } catch (error) {
            console.error('Error in getKPISeries:', error);
            return [];
        }
    }
}

export const dashboardService = new DashboardService();
